import classnames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import Dropdown from '@/components/Dropdown';
import { prettyDate, prettyFloatMoney } from '@/helpers/utils';
import { useGetLoanSecurityByFundraisingId } from '@/query/queries/loan/useGetLoanSecurityByFundraisingId';
import s from './index.module.scss';

export const LoanSecurity = ({ fundraisingID }) => {
  const { t } = useTranslation('loans');
  const {
    data: loanSecurity,
    hasNextPage,
    fetchNextPage,
  } = useGetLoanSecurityByFundraisingId(fundraisingID);

  const hasData = !!loanSecurity?.pages[0]?.total_count;

  if (!hasData) return null;

  return (
    <div className={s.wrapper}>
      <Dropdown
        className={s.dropdown}
        label={
          <div className="loan-info-contracts__header">
            <h2 className="f-article-accent">{t('loan_info.loan_security')}</h2>
          </div>
        }
      >
        {hasData ? (
          <>
            <ol className={s.list}>
              {loanSecurity.pages.map(page =>
                page.list.map((item, index) => (
                  <li key={item.id}>
                    <Trans
                      ns="loans"
                      i18nKey="loan_info.guarantee_letter"
                      values={{
                        index: index + 1,
                        id: item.id,
                        created_at: prettyDate(item.created_at),
                        amount: prettyFloatMoney(item.amount),
                      }}
                    />
                  </li>
                )),
              )}
            </ol>

            {hasNextPage && (
              <div className={s.buttons}>
                <button
                  type="button"
                  className="'f-24 f-500'"
                  onClick={fetchNextPage}
                >
                  {t('loan_info.load_more')}
                </button>
              </div>
            )}
          </>
        ) : (
          <div className={classnames(s.empty, 'f-small-regular')}>
            {t('loan_info.no_loan_security_yet')}
          </div>
        )}
      </Dropdown>
    </div>
  );
};
